import { AUTH_TYPES, TEMPLATE_CATEGORIES } from './constants.js'

export const marketoTemplate = {
	id: 'marketo',
	guid: '23f9b258-99bb-4235-a9ea-60ce189493c3',
	name: 'Marketo',
	category: TEMPLATE_CATEGORIES.MARKETING,
	popularity: 'Enterprise',
	color: '#5c4c9f',
	icon: 'mdi-target',
	description: 'Connect to Marketo Engage for B2B marketing automation.',
	features: ['OAuth2 Auth', 'Lead Management', 'Campaign Automation', 'Scoring'],
	configFields: [
		{ name: 'clientId', label: 'Client ID', type: 'text', required: true, placeholder: 'Enter your Marketo client ID' },
		{ name: 'clientSecret', label: 'Client Secret', type: 'password', required: true, placeholder: 'Enter your Marketo client secret' },
		{ name: 'instanceUrl', label: 'Instance URL', type: 'text', required: true, placeholder: 'https://123-ABC-456.mktorest.com' }
	],
	endpoints: [
		{
			name: 'Create/Update Lead',
			url: '{instance_url}/rest/v1/leads.json',
			method: 'POST',
			description: 'Create or update a lead in Marketo',
			cassieObjectID: -3,
			incrementField: 'SyrenisID',
			resetIncrementValue: false,
			fields: [
				{ name: 'Email1', filter: '' },
				{ name: 'Forename', filter: '' },
				{ name: 'Surname', filter: '' }
			],
			requestBody: `{
				"action": "createOrUpdate",
				"lookupField": "email",
				"input": [
					{
						"email": "[PLACEHOLDER_EMAIL1]",
						"firstName": "[PLACEHOLDER_FORENAME]",
						"lastName": "[PLACEHOLDER_SURNAME]"
					}
				]
			}`,
			headers: [
				{ Name: 'Content-Type', value: 'application/json' }
			],
			successResponses: [
				{ code: 200, message: '' }
			]
		},

		{
			name: 'Set Lead Preference',
			url: '{instance_url}/rest/v1/leads.json',
			method: 'POST',
			description: 'Update lead preference or opt-in status',
			cassieObjectID: -5,
			incrementField: 'PreferenceID',
			resetIncrementValue: false,
			fields: [
				{ name: 'Email1', filter: '' },
				{ name: 'ConsentValue', filter: '' }
			],
			requestBody: `{
				"action": "updateOnly",
				"lookupField": "email",
				"input": [
					{
						"email": "[PLACEHOLDER_EMAIL1]",
						"marketingOptIn": "[PLACEHOLDER_CONSENTVALUE]"
					}
				]
			}`,
			headers: [
				{ Name: 'Content-Type', value: 'application/json' }
			],
			successResponses: [
				{ code: 200, message: '' }
			]
		}

	],
	defaults: {
		endpointAddress: 'https://[instance].mktorest.com',
		authenticationTypeId: AUTH_TYPES.OAUTH2_CLIENT_CREDENTIALS,
		frequencyInSeconds: 0,
		notes: 'Marketo Engage integration for B2B marketing automation and lead management.'
	}
}
